import {Component, Input, OnInit} from '@angular/core';
import {ViewCell} from '@mominsamir/ngx-smart-table';
import {STATUS_ICON_CONFIG_MAP} from '@theme/components/ui/status/status-icon-config';

@Component({
    selector: 'ngx-status-cell',
    template: `
        <div class="status-cell" *ngIf="icon && iconStatus">
            <ng-container *ngIf="commentBox; else defaultIcon">
                <span class="icon-wrapper" [ngClass]="[iconStatus]">
                    <div class="dot"></div>
                    <nb-icon pack="eva" [icon]="icon"></nb-icon>
                </span>
                <span class="status-label" *ngIf="iconLabel">{{ iconLabel }}</span>
            </ng-container>
            <ng-template #defaultIcon>
                <span class="icon-wrapper" [ngClass]="[iconStatus]">
                    <nb-icon pack="eva" [icon]="icon"></nb-icon>
                </span>
                <span class="status-label" *ngIf="iconLabel">{{ iconLabel }}</span>
            </ng-template>
        </div>
    `,
    styleUrls: ['./status-cell.component.scss'],
})
export class StatusCellComponent implements ViewCell, OnInit {
    icon: string;
    iconStatus: string;
    iconLabel: string;
    commentBox: boolean = false;

    @Input() value: any;
    @Input() rowData: any;
    /*
     * Used across entire data management tool for data files, datasets, and snapshots.
     * - Data file: Started, Uploaded, Success, Failed
     * - Dataset: ...
     * - Snapshot: ...
     */
    ngOnInit(): void {
        const config = STATUS_ICON_CONFIG_MAP[this.value] || {
            icon: 'close-circle-outline',
            status: 'basic',
            label: 'Unknown',
        };

        this.icon = config.icon;
        this.iconStatus = config.status;
        this.iconLabel = config.label;
        if (config.commentBox) this.commentBox = !!config.commentBox;
    }
}
